import React, { useState, useRef } from "react";
import {
    Grid,
    Input,
    MenuItem,
    Select,
    InputLabel,
    Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import FormLabel from "@mui/material/FormLabel";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import Switch from "@mui/material/Switch";
import Divider from "@mui/material/Divider";
import FormControlLabel from "@mui/material/FormControlLabel";
import { styled } from '@mui/material/styles';
import MuiGrid from '@mui/material/Grid';
import LocalAirportIcon from "@mui/icons-material/LocalAirport";
import { yellow } from '@mui/material/colors';
import Avatar from '@mui/material/Avatar';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import Radio from '@mui/material/Radio';
import Paper from "@mui/material/Paper";
import Transfer from "./Transfer";

const TransportDetails = ({

    arrivalAirport, setArrivalAirport,
    departureAirport, setDepartureAirport,

    arrivalFlightNumber, setArrivalFlightNumber,
    departureFlightNumber, setDepartureFlightNumber,

    arrivalHour, setArrivalHour,
    departureHour, setDepartureHour,

    arrivalTerminal, setArrivalTerminal,
    departureTerminal, setDepartureTerminal,

    arrivalUmService, setArrivalUmService,
    departureUmService, setDepartureUmService,

    arrivalTransfer, setArrivalTransfer,
    departureTansfer, setDepartureTransfer,


    arrivalComment, setArrivalComment,
    departureComment, setDepartureComment,

    selectedCenter,
    hideTitle,
    isFormInvalid,
    readonly
}) => {

    return (
        <>
            {!hideTitle ?
                <Box sx={{ color: 'primary.main' }}>
                    <Typography fontSize={20} fontWeight={'bold'} marginBottom={2} marginTop={2}>
                        Transport details
                    </Typography>
                </Box> : <></>}

            <Grid container  spacing={3} alignItems="flex-start">
                <Grid item xs={6}>
                    <Transfer
                        title={"Arrival"}
                        airport={arrivalAirport} setAirport={setArrivalAirport}
                        flightNumber={arrivalFlightNumber} setFlightNumber={setArrivalFlightNumber}
                        hour={arrivalHour} setHour={setArrivalHour}
                        terminal={arrivalTerminal} setTerminal={setArrivalTerminal}
                        transfer={arrivalTransfer} setTransfer={setArrivalTransfer}
                        selectedCenter={selectedCenter}
                        umService={arrivalUmService} setUmService={setArrivalUmService}
                        isFormInvalid={isFormInvalid}
                        readonly={readonly}
                        comment={arrivalComment} setComment={setArrivalComment}
                        >
                    </Transfer>
                </Grid>
                <Grid item xs={6}>
                    <Transfer
                        title={"Departure"}
                        airport={departureAirport} setAirport={setDepartureAirport}
                        flightNumber={departureFlightNumber} setFlightNumber={setDepartureFlightNumber}
                        hour={departureHour} setHour={setDepartureHour}
                        terminal={departureTerminal} setTerminal={setDepartureTerminal}
                        transfer={departureTansfer} setTransfer={setDepartureTransfer}
                        selectedCenter={selectedCenter}
                        umService={departureUmService} setUmService={setDepartureUmService}
                        isFormInvalid={isFormInvalid}
                        readonly={readonly}
                        comment={departureComment} setComment={setDepartureComment}
                        >
                    </Transfer>
                </Grid>
            </Grid>
        </>)
}

export default TransportDetails